<template>
  <div :key="env">
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex';

/**
 * :key here causes a redraw when the environment is redrawn!
 */
export default {
  name: 'App',
  computed: {
    ...mapState({
      env: (state) => state.env.data?.environment,
    }),
  },
};
</script>
